// An on/off switch with a 40px tall target, for the drawer's Nascosto. Sized in px, since the root font is 13px.
import { cn } from "@/utils/cn";

interface Props {
  on: boolean;
  /** The accessible name: the switch reads "Nascosto, on". */
  label: string;
  onChange: (on: boolean) => void;
  disabled?: boolean;
}

export function ToggleSwitch({ on, label, onChange, disabled = false }: Props) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!on)}
      className="group grid h-[40px] w-[48px] shrink-0 place-items-center rounded-full focus-visible:outline-none disabled:opacity-50"
    >
      <span
        className={cn(
          "relative block h-[22px] w-[38px] rounded-full transition-colors group-focus-visible:ring-2 group-focus-visible:ring-indigo-400 group-focus-visible:ring-offset-2",
          on ? "bg-gray-500" : "bg-gray-300",
        )}
      >
        <span
          className={cn(
            "absolute left-[2px] top-[2px] h-[18px] w-[18px] rounded-full bg-white shadow-sm transition-transform",
            on ? "translate-x-[16px]" : "translate-x-0",
          )}
        />
      </span>
    </button>
  );
}
